import { IFormValues } from 'components';
import { EPromoScopeType, EPromoValueType } from 'types';

import { EValidatePromoCodeItemsType } from '../../components/PromoCodeField/schema';

export enum ETabsModal {
  GOODS = 'GOODS',
  SERVICES = 'SERVICES',
  TARIFFS = 'TARIFFS',
}

export interface IAvailableItems {
  entity_type: EValidatePromoCodeItemsType;
  entity_id: number;
}

export interface IChosenPositions {
  title: string;
  id: number;
  type?: ETabsModal;
}

export interface IChosenClientItem {
  id: string;
  title: string;
  type: 'client' | 'group';
}

export type TApplicableParam = {
  all: boolean;
  items?: Array<{ id: number; title: string }>;
};

export interface IApplicableParamsParsed {
  goods?: TApplicableParam;
  services?: TApplicableParam;
  tariffs?: TApplicableParam;
}

export interface ISubmitPromoParams {
  values: IFormValues;
  chosenItems: Array<IChosenClientItem>;
  chosenPositions: Array<{ id: number; title: string; type?: ETabsModal }>;
  areas: Array<{ value: EPromoScopeType; active: boolean }>;
  rewardType?: EPromoValueType | null;
}

export interface IBaseFormValues {
  active: boolean;
  is_tracked: boolean;
  valueType: EPromoValueType | null;
  value: number | '';
  clientIds: number[];
  clientGroupIds: number[];
  applicableGoods: number[];
  applicableServices: number[];
  applicableTariffs: number[];
}

export interface IFormValuesCode extends IBaseFormValues {
  code: string;
  amount: number | ''; // кол-во штук
}

export interface IFormValuesCampaign extends IBaseFormValues {
  limit: number | '';
  generation_settings: {
    type: EPromoGenerationType | null;
    prefix: string;
    length: number | '';
  };
}

// ===== ENUMS =====
export enum EPromoGenerationType {
  SYMBOLS = 'SYMBOLS',
  NUMERIC = 'NUMERIC',
  MIX = 'MIX',
}

// ===== BASE ENTITIES =====
export interface User {
  id: number;
  name: string;
  phone?: string;
  email?: string;
}

export interface PromoCampaignCounters {
  total: number;
  used: number;
  available: number;
}

export interface PromoValue {
  type: EPromoValueType;
  value?: number;
}

export interface PromoCampaignGenerationData {
  type: EPromoGenerationType;
  prefix?: string;
  length: number;
}

export interface ScopedClient {
  id: number;
  phone: string;
}

export interface ScopedGroup {
  id: number;
  title: string;
}

export type ClientScopeItem = ScopedClient | ScopedGroup;

// ===== MAIN ENTITIES =====
export interface PromoCampaign {
  id: string;
  title: string;
  description?: string;
  author: User;
  scopes?: EPromoScopeType[];
  generation_settings?: PromoCampaignGenerationData;
  value?: PromoValue;
  counters?: PromoCampaignCounters;
  applicable_params?: string;
  client_scope?: ClientScopeItem[];
  is_tracked: boolean;
  active: boolean;
  active_from?: string;
  active_to?: string;
  created_at: string;
  updated_at: string;
}

export interface PromoCodeEntity {
  id: number;
  author: User;
  client?: User;
  code: string;
  amount?: number;
  value?: PromoValue;
  applicable_params?: string;
  created_at: string;
  is_tracked: boolean;
  active: boolean;
}

// ===== LIST TYPES =====

export interface PromoCampaignList {
  items: PromoCampaign[];
  total: number;
}

export interface PromoCodeList {
  items: PromoCodeEntity[];
  total: number;
}

// ===== INPUTS =====

export interface PromoValueInput {
  type: EPromoValueType;
  value: number;
}

export interface PromoCampaignGenerationInput {
  type: EPromoGenerationType;
  prefix?: string;
  length: number;
}

export interface ApplicableDataInput {
  goods?: number[];
  services?: number[];
  tariffs?: number[];
}

export interface PromoCampaignInput {
  title: string;
  description?: string;
  value: PromoValueInput;
  scopes?: EPromoScopeType[];
  generation_settings: PromoCampaignGenerationInput;
  applicable_params?: ApplicableDataInput;
  clients_scope?: number[];
  client_group_scope?: number[];
  active_from?: string;
  active_to?: string;
  active: boolean;
  is_tracked: boolean;
}

export interface PromoCodeEntityInput {
  client_id?: number;
  value: PromoValueInput;
  amount?: number;
  is_tracked?: boolean;
}
